var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-animation-wrapper"},[_c('div',{staticClass:"logo-wrapper"},[_c('div',{staticClass:"phase-9-logo"},[_c('Phase9FooterLogo')],1)]),_c('Phase9DotAnimation',{attrs:{"dots":30,"hidden-dots":[13, 14, 15, 16]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }